import { BrazeBottomSheetProps } from 'features/home/HomeScreen/components/BrazeBottomSheet/BrazeBottomSheet';
import {
  BrazeContentCard,
  BrazeSuccessProductOfferCard,
} from 'services/engagement/braze/types';

export function isBrazeSuccessProductOfferCard(
  contentCard:
    | BrazeContentCard
    | BrazeSuccessProductOfferCard
    | BrazeBottomSheetProps,
): contentCard is BrazeSuccessProductOfferCard {
  return (
    (contentCard as BrazeSuccessProductOfferCard)
      .illustrationBackgroundColor !== undefined
  );
}

export function isBrazeBottomSheetCard(
  contentCard:
    | BrazeContentCard
    | BrazeSuccessProductOfferCard
    | BrazeBottomSheetProps,
): contentCard is BrazeBottomSheetProps {
  return (contentCard as BrazeBottomSheetProps).disclosureTagline !== undefined;
}
